import moment from 'moment';
import filter from 'lodash/filter';

const surveyHelper = {};

surveyHelper.prepForPush = (data) => {
  let { locations } = data;
  let selected_locations = filter(locations, { value: true });
  let locations_array = [];

  data.survey_type = 'location';

  if (locations && selected_locations.length > 1) {
    selected_locations.map(loc => locations_array.push(loc.apikey));

    data.survey_type = 'locations';
    data.location_apikeys = locations_array;
  }

  if (locations && selected_locations.length === 1) {
    selected_locations.map(loc => locations_array.push(loc.apikey));
    data.survey_type = 'location';
    data.location_apikeys = locations_array;
  }

  if (locations && locations.length === selected_locations.length) {
    data.survey_type = 'vendor';
    data.vendor_apikey = locations[0].vendor_apikey;
  }

  if (data.points !== '') data.points = parseInt(data.points, 10);
  return data;
}

surveyHelper.addLocationsToMulti = (fields, allLocations) => {
  fields = JSON.parse(JSON.stringify(fields));
  fields.locations.value = allLocations.map(loc => {
    return {
      apikey: loc.apikey,
      vendor_apikey: loc.vendor_apikey,
      name: loc.name,
      value: false,
    };
  });

  return fields;
};

export default surveyHelper



/** WEBPACK FOOTER **
 ** ./src/helpers/survey/buildValues.js
 **/